"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.company.checkbox_label': 'Register with company',
    'register.company.form_title': 'Company Information',
    'register.company.section_title': 'Company Information (Optional)',
    'register.company.add_button': 'Add Company',
    'register.company.data_added': 'Company data added successfully',
    'register.company.remove_button': 'Remove Company',
    'register.company.optional_help': 'You can optionally add your company information during registration',
    'register.company.removed': 'Company data removed successfully',
};
